import { useQuery } from '@apollo/client'
import { isAddressFilledOut } from '../../utils/helpers'
import {
  ValidateTestLocationAddress,
  ValidateTestLocationAddressVariables,
  AddressInput,
} from '../../types'
import { VALIDATE_TEST_LOCATION_ADDRESS } from './operations'

interface Props {
  address: AddressInput
  onCompleted?: ({ testLocationId }: { testLocationId: string }) => void
  onError?: () => void
  skip?: boolean
}

export const useValidateTestLocationAddress = ({ address, onCompleted, onError, skip }: Props) => {
  return useQuery<ValidateTestLocationAddress, ValidateTestLocationAddressVariables>(
    VALIDATE_TEST_LOCATION_ADDRESS,
    {
      variables: {
        Address: address,
      },
      onCompleted: ({ validateTestLocation }) => {
        onCompleted?.({ testLocationId: validateTestLocation.id })
      },
      onError,
      skip: !isAddressFilledOut(address) || skip,
    }
  )
}
